import React from "react";
import TopNavigation from "./TopNavigation";
import TopContainer from "./TopContainer";
import InfoSection from "./InfoSection";
import DemoSection from "./DemoSection";
import FeaturesSection from "./FeaturesSection";
import RetailsStoreSection from "./RetailsStoreSection";
import UpgradeYourBusinessSection from "./UpgradeYourBusinessSection";
import FaqSection from "./FaqSection";
import Footer from "./FooterSection";
import { motion, useScroll } from "framer-motion";
import styles from "./index.module.css";
import PackageSection from "./PackageSection";
import PosViewSection from "./PosViewSection";
import HowToGetStartedSection from "./HowToGetStarted";
import BusinessGrowSection from "./BusinessGrowSection";
import TouchPos from "./TouchPos";

const Layout = () => {
  const { scrollYProgress } = useScroll();

  return (
    <>
      <motion.div
        className={styles.progressBar}
        style={{ scaleX: scrollYProgress }}
      />
      <div className={styles.container}>
        <div id="home">
          <TopNavigation />
        </div>
        <TopContainer />
        <div id="info">
          <InfoSection />
        </div>
        
        <div id="touch-pos">
          <TouchPos />
        </div>

        {/* Numbers Section */}
        <BusinessGrowSection />
       
        <div id="features">
          <FeaturesSection />{" "}
        </div>

        <PosViewSection />


        {/* <div id="pricing">
          <PackageSection />
          </div> */}


          <UpgradeYourBusinessSection />
        {/* <RetailsStoreSection /> */}
        <HowToGetStartedSection />

      
        <div id="faq">
          <FaqSection />
        </div>
        <div id="contact">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;